import React from "react"; 
const RequiredAsterisk = () => {
  return <span className='text-danger'>*</span>;
};

export default RequiredAsterisk;
